import React from 'react'
import styles from './ExecutiveSummary.module.css'

const ExecutiveSummaryWeekly = ({ weeklyStructure }) => {
  if (!weeklyStructure) return null

  return (
    <div>
      <div className={styles.weeklyGrid}>
        <div className={styles.weeklyCard} style={{ backgroundColor: '#f6ffed', border: '1px solid #b7eb8f' }}>
          <div className={styles.weeklyValue} style={{ color: '#52c41a' }}>
            {weeklyStructure.current.exercise_days}
          </div>
          <div className={styles.weeklyLabel}>Current Exercise Days</div>
        </div>
        <div className={styles.weeklyCard} style={{ backgroundColor: '#e6f4ff', border: '1px solid #91caff' }}>
          <div className={styles.weeklyValue} style={{ color: '#1677ff' }}>
            {weeklyStructure.target.exercise_days}
          </div>
          <div className={styles.weeklyLabel}>Target Exercise Days</div>
        </div>
        <div className={styles.weeklyCard} style={{ backgroundColor: '#fff7e6', border: '1px solid #ffd591' }}>
          <div className={styles.weeklyValue} style={{ color: '#fa8c16' }}>
            {weeklyStructure.current.rest_days}
          </div>
          <div className={styles.weeklyLabel}>Current Rest Days</div>
        </div>
        <div className={styles.weeklyCard} style={{ backgroundColor: '#f0f5ff', border: '1px solid #adc6ff' }}>
          <div className={styles.weeklyValue} style={{ color: '#722ed1' }}>
            {weeklyStructure.target.rest_days}
          </div>
          <div className={styles.weeklyLabel}>Target Rest Days</div>
        </div>
      </div>
      <div className={styles.focusSection}>
        <div className={styles.focusLabel}>Current</div>
        <div className={styles.focusText}>{weeklyStructure.where_i_stand}</div>
        <div className={styles.focusLabel}>Desired</div>
        <div className={styles.focusText}>{weeklyStructure.what_to_focus_on}</div>
        <div className={styles.focusLabel}>Action</div>
        <ul className={styles.focusActionList}>
          {weeklyStructure.what_to_do && weeklyStructure.what_to_do.slice(0, 2).map((item, idx) => (
            <li key={idx} className={styles.focusActionItem}>
              <span role="img" aria-label="lightning" className={styles.focusActionIcon}>⚡</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ExecutiveSummaryWeekly
